import { PaymentMethodList, PaymentMethodEdit } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

const name = 'paymentMethod';

const icon = 'fa-credit-card';

export default {
    pages: {
        PaymentMethodList,
        PaymentMethodEdit,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name,
    icon,
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/index.ts